
export default function (element) {

    var target = element || document;

    $(target).find('select[data-autocomplete]').each((i, item) => {

        initAutocomplete($(item));
    });
};

export function initAutocomplete($item) {

    var config = createConfigBasedOnAttributes($item);
    $item.select2(config);
}

function createConfigBasedOnAttributes($item) {

    const pageSize = $item.data('page-size') || 20;
    const propertyName = $item.data('autocomplete');
    
    let config = {
        placeholder: $item.data('placeholder'),
        allowClear: false,
        width: '100%',
        tags: true,
        ajax: {
            url: $item.data('odata-url'),
            dataType: "json",
            delay: 200,
            data: (params) => {

                params.term = (params.term || '').replace(/'/g, '\'\'');    // escape possible single quotes
                params.page = params.page || 1;

                // OData query returning distinct possible values for given property
                var query = `filter(startswith(${propertyName},'${params.term}'))/groupby((${propertyName}))`;

                return {
                    "$apply": query,
                    "$count": true,
                    "$top": pageSize,
                    "$skip": (params.page - 1) * pageSize,
                };
            },
            processResults: function (data, params) {

                params.page = params.page || 1;

                return {
                    results: $.map(data.value, item => ({ id: item[propertyName], text: item[propertyName] }) ),
                    pagination: {
                        more: (params.page * pageSize) < data["@odata.count"]
                    }
                };
            },
        },
        templateResult: function (item) {
            return item.text;
        },
        templateSelection: function (item) {
            return item.text;
        },
    };

    return config;
}


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/initializers/autocomplete.js